import { Package } from "lucide-react";

// Kept at the existing call site: Shared and distance alone do not establish
// an avoided trip or measured emissions, even after a delivery is completed.
export default function CO2SavingsCard({ delivery_type, className = "" }) {
  if (delivery_type !== "shared") return null;

  return (
    <section className={`card-soft p-5 sm:p-6 ${className}`} data-testid="shared-delivery-service">
      <div className="flex items-start gap-3">
        <span className="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl bg-dapnow-blue-soft text-dapnow-blue">
          <Package className="h-5 w-5" />
        </span>
        <div className="min-w-0">
          <p className="overline">Ordine Shared</p>
          <p className="mt-1 text-sm text-dapnow-muted">Shared è la categoria registrata per questa spedizione. Consulta lo stato e i dettagli dell'ordine.</p>
          <p className="mt-2 text-xs text-dapnow-muted">Il nuovo servizio Shared per driver privati è in arrivo e non è ancora prenotabile. Le registrazioni esistenti restano consultabili.</p>
          <a href="/become-driver" className="inline-block mt-2 text-xs font-semibold text-dapnow-blue underline">Richiedi informazioni</a>
        </div>
      </div>
    </section>
  );
}
